<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="cabecalho-pagina-meus-pedidos">
          <div class="m-icone esquerda">
            <a @click="$router.back()" style="cursor: pointer" class="icone-voltar m-d"></a>
          </div>
          <h2>Minhas Solicitações</h2>
        </div>
      </div>
    </div>
    <div class="margem container">
      <div class="bloco margem bloco-lista-meus-pedidos">
        <!-- <p class="fonte-menor fonte-fraca m-b">Acompanhe o status dos visitantes que você informou e altere quando
          necessário.</p> -->
        <!-- <div class="pesquisa m-b" style="max-width: 320px;">
          <input v-model="filtro" type="text" placeholder="Pesquisar por nome ou empresa" @input="pesquisar" />
          <a class="icone-pesquisa" title="Pesquisar"></a>
        </div> -->
        <div class="tabela-meus-pedidos-scroll">
          <table class="tabela tabela-meus-pedidos">
            <thead>
              <tr>
                <th v-if="permissoes.includes(256)">Data solicitação</th>
                <th class="th-texto">Visitante(s)</th>
                <th class="th-texto">Empresa</th>
                <th v-if="permissoes.includes(256)">Data visita</th>
                <th>Status</th>
                <th class="th-acoes">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lista" :key="item.id || item._id">
                <td v-if="permissoes.includes(256)">{{ formatarData(item.dataSolicitacao) }}</td>
                <td class="td-texto">{{ textoVisitantes(item) }}</td>
                <td class="td-texto">{{ item.empresaOrigem || "—" }}</td>
                <td v-if="permissoes.includes(256)">{{ textoDataVisita(item) }}</td>
                <td>
                  <span class="chip" :class="classeStatus(item.statusAgendamento, item.cancelada)">{{
                    textoStatus(item.statusAgendamento, item.cancelada)
                  }}</span>
                </td>
                <td class="col-acoes">
                  <div class="acoes-celula">
                    <div class="acoes-links">
                      <router-link
                        :to="{ path: '/solicitacao-visita/editar/' + (item.id || item._id), query: { minhas: '1' } }"
                        class="link-acao"
                        :title="tituloLinkPedido(item)"
                      >
                        {{ textoLinkPedido(item) }}
                      </router-link>
                      <template v-if="podeCancelarPedido(item)">
                        <span class="acoes-sep" aria-hidden="true">·</span>
                        <button
                          type="button"
                          class="link-acao btn-cancelar"
                          title="Cancelar pedido"
                          :disabled="cancelandoId === (item.id || item._id)"
                          @click="confirmarCancelar(item)"
                        >
                          <i v-if="cancelandoId === (item.id || item._id)" class="fas fa-spinner fa-spin"></i> Cancelar
                        </button>
                      </template>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="lista.length === 0 && !carregando">
              <tr>
                <td :colspan="permissoes.includes(256) ? 6 : 4" class="celula-vazia">Nenhum pedido encontrado.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="lastPage > 1" class="paginacao-lista">
          <button type="button" @click="irPagina(page - 1)" :disabled="page <= 1">Anterior</button>
          <span class="paginacao-lista-info">Página {{ page }} de {{ lastPage }}</span>
          <button type="button" @click="irPagina(page + 1)" :disabled="page >= lastPage">Próxima</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { createToaster } from "@meforma/vue-toaster";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import { textoStatus as textoStatusConfig, classeStatus as classeStatusConfig } from "@/config/status-visita";
import { formatarPeriodoVisitaPtBr, formatarDataVisitaPtBr, isDataVisitaEstritamentePassada } from "@/utils/visita-data";
import { getPermissao } from "@/services/permissaoService";

const toaster = createToaster({ position: "top-right" });

export default {
  name: "MeusPedidosView",

  data() {
    return {
      lista: [],
      page: 1,
      lastPage: 1,
      filtro: "",
      carregando: false,
      debounce: null,
      cancelandoId: null,
      permissoes: [],
    };
  },

  async created() {
    this.permissoes = await getPermissao();
    this.buscar();
  },

  methods: {
    textoVisitantes(item) {
      const list = item.listaVisitantes;
      if (Array.isArray(list) && list.length > 1) {
        const nomes = list.map((v) => v.nomeCompleto).filter(Boolean);
        return nomes.length > 0 ? nomes.join(", ") : `Visita em grupo (${list.length} pessoas)`;
      }
      return item.nomeCompleto || "—";
    },
    formatarData(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      return d.toLocaleDateString("pt-BR");
    },
    textoStatus(s, cancelada) {
      return textoStatusConfig(s, cancelada);
    },
    classeStatus(s, cancelada) {
      return classeStatusConfig(s, cancelada);
    },
    /** data_visita / dataVisita (instância do modelo ou objeto da API) */
    rawDataVisita(item) {
      if (!item) return null;
      return item.dataVisita ?? item.data_visita ?? null;
    },
    textoDataVisita(item) {
      const s = formatarPeriodoVisitaPtBr(this.rawDataVisita(item), item?.dataVisitaFim ?? item?.data_visita_fim);
      if (s) return s;
      const fallback = formatarDataVisitaPtBr(this.rawDataVisita(item));
      return fallback || "—";
    },
    visitaSomenteLeituraPorData(item) {
      return isDataVisitaEstritamentePassada(
        this.rawDataVisita(item),
        item?.dataVisitaFim ?? item?.data_visita_fim
      );
    },
    textoLinkPedido(item) {
      if (item.cancelada || this.visitaSomenteLeituraPorData(item)) return "Ver";
      return "Ver / Alterar";
    },
    tituloLinkPedido(item) {
      if (item.cancelada) return "Ver detalhes";
      if (this.visitaSomenteLeituraPorData(item)) return "Ver detalhes (data da visita já passou)";
      return "Ver e alterar";
    },
    podeCancelarPedido(item) {
      return !item.cancelada && !this.visitaSomenteLeituraPorData(item);
    },
    pesquisar() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.page = 1;
        this.buscar();
      }, 400);
    },
    irPagina(p) {
      if (p < 1 || p > this.lastPage) return;
      this.page = p;
      this.buscar();
    },
    confirmarCancelar(item) {
      if (this.visitaSomenteLeituraPorData(item)) {
        toaster.show("Não é possível cancelar um pedido cuja data da visita já passou.", { type: "warning" });
        return;
      }
      const id = item.id || item._id;
      const nome = this.textoVisitantes(item);
      if (!window.confirm(`Cancelar o pedido de visita de "${nome}"? O pedido ficará com status Cancelada.`)) return;
      this.cancelandoId = id;
      solicitacaoVisitaService
        .cancelar(id)
        .then(() => {
          toaster.show("Pedido cancelado.", { type: "success" });
          this.buscar();
        })
        .catch((err) => {
          console.error(err);
          toaster.show("Erro ao cancelar pedido.", { type: "error" });
        })
        .finally(() => {
          this.cancelandoId = null;
        });
    },
    async buscar() {
      this.carregando = true;
      try {
        const res = await solicitacaoVisitaService.listar({
          page: this.page,
          search: this.filtro || undefined,
          minhas: true,
        });
        this.lista = res.data || [];
        this.lastPage = res.last_page ?? 1;
        this.page = res.current_page ?? 1;
      } catch (err) {
        console.error(err);
        this.lista = [];
        this.lastPage = 1;
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
<style scoped>
.cabecalho-pagina-meus-pedidos {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bloco-lista-meus-pedidos {
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.tabela-meus-pedidos-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 -0.25rem;
}

.tabela-meus-pedidos {
  min-width: 880px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: center;
}

.tabela-meus-pedidos thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cor-fonte-fraca);
  font-weight: 700;
  padding: 0.65rem 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
  background: transparent;
}

.th-acoes {
  text-align: left !important;
  min-width: 10rem;
}

.th-texto {
  text-align: left !important;
}

.tabela-meus-pedidos tbody td {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--cor-separador);
  font-size: 0.92rem;
}

.td-texto {
  text-align: left;
}

.tabela-meus-pedidos tbody tr:last-child td {
  border-bottom: none;
}

.celula-vazia {
  text-align: center;
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
  padding: 1.5rem 0.5rem !important;
}

.paginacao-lista {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid var(--cor-separador);
}

.paginacao-lista-info {
  font-size: 0.9rem;
  color: var(--cor-fonte-fraca);
}

.acoes-celula {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.acoes-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.15rem 0.25rem;
  font-size: 0.88rem;
}

.acoes-sep {
  color: var(--cor-fonte-fraca);
  user-select: none;
  padding: 0 0.05rem;
}

.status-pendente {
  background: var(--cor-cinza);
  color: var(--cor-fonte-fraca);
}

.status-processo,
.status-confirmada,
.status-em-visita {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.status-concluido {
  background: var(--cor-primaria-fraca);
  color: var(--cor-sucesso);
}

.status-cancelada {
  background: var(--cor-cinza);
  color: var(--cor-erro);
}

.col-acoes {
  white-space: normal;
  max-width: 14rem;
  text-align: left;
  vertical-align: middle;
}

.link-acao {
  color: var(--cor-primaria-forte);
  text-decoration: none;
  font-weight: 600;
  border-radius: 4px;
  padding: 0.1rem 0.05rem;
}

.link-acao:hover {
  text-decoration: underline;
  color: var(--cor-primaria);
}

.btn-cancelar {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  color: var(--cor-erro);
}

.btn-cancelar:hover:not(:disabled) {
  text-decoration: underline;
}

.btn-cancelar:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
